import { graphql } from '@graphql/__generated'

export const SET_CHECKIN_FOR_ATTENDEE = graphql(`
	mutation setCheckInforAttendee (
	  $email: String
	  $ticketCode: String
	  $eventId: String!
      $checkInStatus: String!
	) {
	  setCheckInforAttendee (
	    email: $email
	    ticketCode: $ticketCode
	    eventId: $eventId
        checkInStatus: $checkInStatus
	  )
	}
`)
